var index = {
  icon: {
    color: '{form.field.icon.color}'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
